import { Tooltip } from 'antd';
import React from 'react';
import { ReactComponent as RefreshIcon } from '../../assets/svg/rotate-right-solid.svg';
import { TOOLTIP_Z_INDEX } from './constants';

const RefreshButton = ({ onRefresh, loading, title = 'Refresh' }) => {
  const handleRefresh = () => {
    if (!loading) onRefresh?.();
  };

  return (
    <Tooltip title={title} placement="top" zIndex={TOOLTIP_Z_INDEX}>
      <span
        role="button"
        tabIndex={0}
        aria-label={title}
        aria-busy={loading}
        className={`inventory-units-refresh ${loading ? 'is-loading' : ''}`}
        onClick={handleRefresh}
        onKeyDown={(e) => {
          if (e?.key === 'Enter' || e?.key === ' ') handleRefresh();
        }}
      >
        <RefreshIcon className="svg-icon" />
      </span>
    </Tooltip>
  );
};

export default RefreshButton;
